<template>
  <div>
    <div v-if="!isCreate && !isBatchTrade && !isBatchGenerateQuotation">
      <!-- 搜索 -->
      <table-search
        v-if="type!=='today-trade'"
        @search="fetchList(1)"
        @reset="handleReset"
      >
        <template v-slot:basic>
          <el-form-item
            label="商品类目"
            class="datePicker"
          >
            <el-select
              v-model="query.varietyCode"
              placeholder="请选择"
              clearable
              @change="selectVarietyChange"
            >
              <el-option
                v-for="(item) in varietyList"
                :key="item.code"
                :label="item.shortName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select
              v-model="query.goodsBrandCode"
              placeholder="请选择"
              clearable
              @change="selectBrandChange"
            >
              <el-option
                v-for="item in brandList"
                :key="item.k"
                :label="item.v"
                :value="item.k"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品状态">
            <el-select
              v-model="query.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in $key.myStore.tradeStatus"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="交货地点"
          >
            <el-input v-model.trim="query.pickupPosition" />
          </el-form-item>
        </template>
      </table-search>

      <!-- 导出 -->
      <inquery-result
        v-if="type!=='today-trade'"
        :is-export="false"
      />

      <!-- 表格 -->
      <el-table
        ref="zTable"
        :data="tableData"
      >
        <af-table-column
          prop="varietyName"
          label="商品类目"
        />
        <af-table-column
          label="品牌"
        >
          <template v-slot="scope">
            {{ scope.row.attrList.find(item=>item.attrCode==='brand') ? scope.row.attrList.find(item=>item.attrCode==='brand').v : '' }}
          </template>
        </af-table-column>

        <af-table-column
          prop="priceType"
          label="报价类型"
        >
          <template v-slot="scope">
            {{ scope.row.priceType | keyFilter('myStore','priceType') }}
          </template>
        </af-table-column>
        <af-table-column
          prop="priceList"
          label="报价"
        >
          <template v-slot="scope">
            <div v-if="scope.row.priceType==='JTJ'">
              <el-popover
                placement="right"
                trigger="hover"
                width="300"
              >
                <el-table :data="scope.row.priceList">
                  <el-table-column
                    prop="unitPrice"
                    label="单价"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.unitPrice | thousandMark }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="min"
                    label="购买量(起购量)"
                  />
                </el-table>
                <el-tag slot="reference">
                  {{ scope.row.priceList && scope.row.priceList.length }}
                </el-tag>
              </el-popover>
            </div>
            <div v-else>
              {{ scope.row.priceList && scope.row.priceList[0].unitPrice | thousandMark }}
            </div>
          </template>
        </af-table-column>
        <af-table-column
          label="挂牌总库存"
        >
          <template v-slot="scope">
            {{ Number(scope.row.sellQuantity) + Number(scope.row.remainQuantity) }}
          </template>
        </af-table-column>
        <af-table-column
          prop="remainQuantity"
          label="剩余库存"
        />
        <af-table-column
          prop="status"
          label="状态"
        >
          <template v-slot="scope">
            {{ scope.row.status | keyFilter('myStore','tradeStatus') }}
          </template>
        </af-table-column>
        <af-table-column
          prop="pickupPosition"
          label="交货地点"
        />
        <af-table-column
          prop="unsettleQty"
          label="操作"
          fixed="right"
        >
          <template v-slot="scope">
            <el-button
              v-if="scope.row.status!=='1'"
              type="text"
              @click="toUpdateTrade(scope.row)"
            >
              调整库存
            </el-button>
            <el-button
              v-if="scope.row.status==='0'"
              type="text"
              @click="toCancel(scope.row)"
            >
              下架
            </el-button>
          </template>
        </af-table-column>
      </el-table>
      <pagination
        :data="pageData"
        :is-init="false"
        @retrieve="fetchList"
      />
    </div>
    <adjust-quantity
      v-if="adjustQuantityVisible"
      type="update"
      :adjust-quantity-visible="adjustQuantityVisible"
      :detail-data="detailData"
      @refresh="fetchList(query.currentNo)"
      @close="adjustQuantityVisible=false"
    />
  </div>
</template>
<script>
import api from '@/api'
import AdjustQuantity from './components/adjust-quantity'
import { formatTime } from '@/utils/util'
import { varietyBrandMixin } from '@/views/my-store/components/mixin'

function Query () {
  return {
    currentNo: '1',
    pageSize: '10',
    varietyCode: '',
    goodsBrandCode: '',
    tradeStatus: '',
    pickupPosition: '',
    attrList: []
  }
}
export default {
  name: 'StoreTrade',
  components: {
    AdjustQuantity
  },
  mixins: [varietyBrandMixin],
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      query: new Query(),
      tableData: [],
      pageData: {},
      isCreate: false,
      isBatchTrade: false,
      isBatchGenerateQuotation: false,
      detailData: {},
      updetaPriceVisible: false,
      adjustQuantityVisible: false,
    }
  },
  created () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (this.type === 'today-trade') {
        this.query.startTime = this.$dayjs(new Date()).format('YYYY-MM-DD 00:00:00')
        this.query.endTime = formatTime(this, new Date(), 1)
      }
      this.query.currentNo = currentNo || this.query.currentNo
      this.query.pageSize = pageSize || this.query.pageSize
      let res = await api.myStore.getTradeData(this.query)
      this.tableData = res.data.rows
      this.pageData = res.data
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    async getDetail (row) {
      const res = await api.myStore.getTradeDetail(row.id)
      return res.data
    },
    async toUpdateTrade (row) {
      this.detailData = await this.getDetail(row)
      this.adjustQuantityVisible = true
    },
    toCancel (row) {
      this.$confirm('此操作将永久下架该挂牌, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        api.myStore.cancelTrade(row.id).then(res => {
          this.$message.success('操作成功')
          this.fetchList(this.query.currentNo)
        })
      }).catch(() => {

      })
    },

  }
}

</script>
